import { render, staticRenderFns } from "./acceptStudentModal.vue?vue&type=template&id=4fe15c73&"
import script from "./acceptStudentModal.vue?vue&type=script&lang=js&"
export * from "./acceptStudentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports